module.exports = __webpack_public_path__ + "img/kafeizong.43de2661.png";